import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Flex, Text } from 'Components/Base';
import { get } from 'Components/Base/constants';

const HiddenCheckboxInput = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  display: none;
`;

const SelectableWrapper = styled((props) => (
  <Flex as="label" justifyContent={'center'} alignItems={'center'} px={7} py={3} {...props} />
))`
  ${({ checked }) => css`
    cursor: pointer;
    border: 2px solid ${checked ? get('colors.primary') : get('colors.greyscale.grey5')};
    background-color: ${checked ? get('colors.primaryLight') : get('colors.transparent')};
    border-radius: 100px;
  `}
`;

const Selectable = ({ checked, name, label, disabled, value, onChange, ...props }) => {
  return (
    <SelectableWrapper checked={checked} {...props}>
      <Text>{label}</Text>
      <HiddenCheckboxInput
        type={'checkbox'}
        checked={checked}
        name={name}
        onChange={onChange}
        value={value}
        disabled={disabled}
      />
    </SelectableWrapper>
  );
};

Selectable.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default Selectable;
